import {
    ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL,
    ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL,
    ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES,
    ACTIVATE_CAMERA_SIM_CARD_REQUEST,
    ACTIVATE_CAMERA_SIM_CARD_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    devices: [],
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case ACTIVATE_CAMERA_SIM_CARD_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload }

        case ACTIVATE_CAMERA_SIM_CARD_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ACTIVATE_CAMERA_SIM_CARD_REQUEST:
            return { ...state, loading: true }

        case ACTIVATE_CAMERA_SIM_CARD_RESULT:
            return { ...state, loading: false, result: action.payload }

        case ACTIVATE_CAMERA_SIM_CARD_UPDATE_DEVICES:
            return { ...state, devices: action.payload }

        case CLEAR_REDUX:
            return ["", "ACTIVATE_CAMERA_SIM_CARD"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};